import jwtAuthAxios from "../auth/jwtAuth";

// Sección «Reportes»: tipos disponibles, opciones del formulario y vista previa. El PDF se pide como una descarga
// (generatedFileServices.requestReport).
const reportServices = {};

reportServices.getTypes = async () => {
    const { data } = await jwtAuthAxios.get("/automations/reports/types");
    return data;
};

reportServices.getOptions = async (type, storeId) => {
    const { data } = await jwtAuthAxios.get("/automations/reports/options", { params: { type, store_id: storeId } });
    return data;
};

reportServices.preview = async (type, params) => {
    const { data } = await jwtAuthAxios.post("/automations/reports/preview", { type, params }, { silentErrors: true });
    return data;
};

export default reportServices;
